import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
} from '@heroicons/react/20/solid';
import React from 'react';
import ReactPaginate from 'react-paginate';

import { PaginationArrowProps, PaginationProps } from './pagination-types';

function PaginationNumber({
  total,
  page,
  onChangePage,
  hrefBuilder,
}: PaginationProps) {
  const handlePageClick = (event: { selected: number }) => {
    onChangePage(event.selected + 1);
  };

  return (
    <nav className="flex-start flex">
      <div className="-mt-px flex">
        <ReactPaginate
          onPageChange={handlePageClick}
          breakLabel="..."
          nextLabel=""
          previousLabel=""
          pageRangeDisplayed={5}
          forcePage={page - 1}
          containerClassName={'flex-start flex'}
          breakClassName="font-title text-3xl"
          pageCount={total}
          pageLinkClassName="font-title inline-flex px-4 text-blue-500 hover:text-gray-700"
          pageClassName="text-3xl font-extrabold"
          activeLinkClassName="text-gray-700"
          hrefBuilder={(...arguments_) => hrefBuilder?.(...arguments_)}
          hrefAllControls={Boolean(hrefBuilder)}
        />
      </div>
    </nav>
  );
}

function PaginationArrow({
  onPrevClick,
  onNextClick,
  canGoPrev,
  canGoNext,
}: PaginationArrowProps) {
  return (
    <nav className="flex items-center justify-center gap-7">
      <button
        disabled={!canGoPrev}
        className="inline-flex items-center rounded-full bg-primary p-2 hover:bg-blue-700 disabled:bg-slate-200"
        ref={onPrevClick}
      >
        <ArrowLongLeftIcon className="h-8 w-8 text-white" aria-hidden="true" />
        <span className="sr-only">left</span>
      </button>
      <button
        disabled={!canGoNext}
        className="inline-flex items-center rounded-full bg-primary p-2 hover:bg-blue-700 disabled:bg-slate-200"
        ref={onNextClick}
      >
        <ArrowLongRightIcon className="h-8 w-8 text-white" aria-hidden="true" />
        <span className="sr-only">right</span>
      </button>
    </nav>
  );
}

export { PaginationArrow, PaginationNumber };
